import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class CandidateMatchModel {
  uid: string = ""
  name: string = ""
  description: string = ""
  score: number = 0

  constructor(
    data: {
      uid: string
      name: string
      description: string
      score: number
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.description = data.description
      this.score = data.score
    }
  }
}
